module.exports = __webpack_public_path__ + "static/img/543.9db6b94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/543.png
// module id = 1214
// module chunks = 12